module.exports = __webpack_public_path__ + "static/media/blogspin.12477b40.svg";